import React from 'react';

// styles
import styles from "../Aboutus.module.css"

// images
// import testImg1 from "../../../../assets/Group1.png"
// import testImg2 from "../../../../assets/Group2.png"
// import testImg3 from "../../../../assets/Group3.png"
// import testImg4 from "../../../../assets/Rectangle4.png"

const AboutusText = ({ data }) => {
    return (
        <>
            <section className='w-100 position-relative d-flex align-items-start justify-content-md-between justify-content-center my-5 flex-wrap'>
                <div className='ms-md-3 ms-0 d-flex align-items-center justify-content-center mt-5 flex-wrap'>
                    <div className="w-100 d-flex align-items-center justify-content-center">
                        {/* <img className={`my-md-2 my-3 ${styles.img1}`} src={testImg1} alt="img" /> */}
                        <img className={`my-md-2 my-3 ${styles.img1}`} src={`https://backdev.azrmelk.com/images/AboutUsImages/${data.secondImageName}`} alt="درباره آذر ملک" loading='lazy'/>
                    </div>
                </div>
                <div className="px-3 py-4 d-flex flex-column justify-content-center align-items-start mt-5">
                    <h2 className={styles.header_title}>{data?.secondTitle}</h2>
                    <p className={`text-wrap ${styles.pretext2}`}>
                        {data?.secondDescription}
                    </p>
                </div>
            </section>
        </>
    );
};

export default AboutusText;